export default __webpack_public_path__ + "static/media/elpoF.d5f4a527.png";